import { z } from "zod";

export interface PublicationTheme {
  id: number;
  logo_url: string;
  color_primary: string;
  color_secondary: string;
  favicon_url: string;
  name: string;
  id_language_1: number;
  banners_visible: boolean;
  news_visible?: boolean;
  about_text_short: string;
  domain: string;
  publisher: string;
  index_logo_visible: boolean;
  issn: string;
  e_issn: string;
  historic_archive_url: string;
  doi_prefix: string;
  plumx_visible: boolean;

  // Incremental compatibility fields while publication consumers migrate to theme.
  keywords_limit?: number;
  abstract_word_limit?: number;
  orcid_required_on_authors?: boolean;
  author_optional_field_job_description?: boolean;
  author_optional_field_specialisation?: boolean;
  author_optional_field_specialisation_2?: boolean;
  author_optional_field_country?: boolean;
  author_optional_field_city?: boolean;
  article_counter?: string;
  chat_available?: boolean;
  associated_editors?: boolean;
  reviewers_can_be_suggested?: boolean;
  abbreviation?: string;
  slug?: string;
  required_files_to_publish?: string;
  additional_files?: string;
  ahead_of_print?: boolean;
  footer_text?: string;
  google_analytics_id?: string;
  internal_mailbox?: string;
  editors_notification_mails?: string;
  editors_cc?: boolean;
  editors_cc_mails?: string;
  can_download_without_login?: boolean;
  id_publication_review_type?: number;
  id_language_2?: number;
  id_language_3?: number;
  license_type?: string | null;
  editorial_process?: string;
  title_page?: boolean;
  revision_files_preview?: boolean;

  how_to_review_file_url?: string;
}

export interface publicationTypes {
  domain: string;
  internal_mailbox: string;
  about_text_long: string;
  address?: string;
  reviewers_can_be_suggested: boolean;
  disabled_date: string;
  abbreviation: string;
  banner_policy: number;
  created_by: number;
  issn: string;
  color_primary: string;
  associated_editors: boolean;
  modified_by: string;
  e_issn: string;
  color_secondary: string;
  production_platform: boolean;
  optional_files_instructions: string;
  flag_disabled: boolean;
  disabled_by: string;
  slug: string;
  publisher: string;
  id_language_1: number;
  publication_platform: boolean;
  creation_date: string;
  name: string;
  doi_prefix: string;
  id_language_2: number;
  continuous_publication: boolean;
  id_supplier: number;
  logo_url: string;
  editorial_process: string;
  id_language_3: number;
  ahead_of_print: boolean;
  modified_date: string;
  id: number;
  favicon_url: string;
  about_text_short: string;
  id_publication_review_type: number;
  society?: string;
  article_counter?: string;
  required_files_to_publish: string;
  publishing_cost?: string;
  financing_text: string;
  privacy_policy?: string;
  legal_notice?: string;
  correspondence_contact: string;
  license_type?: string;
  openaccess_text?: string;
  copyright_text?: string;
  ethics_text?: string;
  rules_text?: string;
  comitee_text?: string;
  publish_rules_general_aspects: string;
  publish_rules_admission_process: string;
  publish_rules_faq: string;
  publish_rules_preparation_and_send: string;
  editorial_board?: string;

  google_analytics_id?: string;
  historic_archive_url?: string;
  publish_rules_manuscript_types: string;
  publish_rules_ethical_commitment: string;
  orcid_required_on_authors: boolean;

  banner_1_url: string;
  banner_2_url: string;
  banner_3_url: string;
  banner_4_url: string;
  banner_5_url: string;
  banner_6_url: string;
  banner_7_url: string;
  banner_8_url: string;
  banner_9_url: string;
  banner_10_url: string;
  banner_11_url: string;
  banner_12_url: string;
  banner_13_url: string;
  banner_14_url: string;
  banner_15_url: string;
  banner_16_url: string;
  banner_17_url: string;
  banner_18_url: string;
  banner_19_url: string;
  banner_20_url: string;

  banner_1_type: number;
  banner_2_type: number;
  banner_3_type: number;
  banner_4_type: number;
  banner_5_type: number;
  banner_6_type: number;
  banner_7_type: number;
  banner_8_type: number;
  banner_9_type: number;
  banner_10_type: number;
  banner_11_type: number;
  banner_12_type: number;
  banner_13_type: number;
  banner_14_type: number;
  banner_15_type: number;
  banner_16_type: number;
  banner_17_type: number;
  banner_18_type: number;
  banner_19_type: number;
  banner_20_type: number;

  banner_1_visible: boolean;
  banner_2_visible: boolean;
  banner_3_visible: boolean;
  banner_4_visible: boolean;
  banner_5_visible: boolean;
  banner_6_visible: boolean;
  banner_7_visible: boolean;
  banner_8_visible: boolean;
  banner_9_visible: boolean;
  banner_10_visible: boolean;
  banner_11_visible: boolean;
  banner_12_visible: boolean;
  banner_13_visible: boolean;
  banner_14_visible: boolean;
  banner_15_visible: boolean;
  banner_16_visible: boolean;
  banner_17_visible: boolean;
  banner_18_visible: boolean;
  banner_19_visible: boolean;
  banner_20_visible: boolean;

  footer_text: string;
  editors_notification_mails: string;
  editors_cc: boolean;
  editors_cc_mails: string;

  metrics: string;
  additional_files: string;

  telefono: string;
  index_logo_visible: boolean;
  banners_visible: boolean;
  news_visible?: boolean;

  abstract_word_limit: number;
  keywords_limit: number;

  title_page: boolean;
  can_download_without_login: boolean;
  author_optional_field_job_description: boolean;
  author_optional_field_specialisation: boolean;
  author_optional_field_specialisation_2: boolean;
  author_optional_field_country: boolean;
  author_optional_field_city: boolean;

  chat_available: boolean;
  revision_files_preview: boolean;
}

export interface requestPublicationTypes {
  name: string;
  supplier_name: string;
  slug: string;
  domain: string;
  abbreviation: string;

  //Añadido por alex
  institution_name: string;
  review_type: string;

  issn: string;
  e_issn: string;
  publisher: string;
  doi_prefix: string;
  logo_url: string;
  favicon_url: string;
  internal_mailbox: string;
  historic_archive_url: string;
  color_primary: string;
  color_secondary: string;
  id_language_1: number;
  id_language_2: number;
  id_language_3: number;
  about_text_short: string;
  about_text_long: string;
  comitee_text: string;
  rules_text: string;
  ethics_text: string;
  copyright_text: string;
  license_type: string;
  financing_text: string;
  publishing_cost: string;
  correspondence_contact: string;
  banner_policy: number;
  associated_editors: boolean;
  production_platform: boolean;
  publication_platform: boolean;
  continuous_publication: boolean;
  ahead_of_print: boolean;
  reviewers_can_be_suggested: boolean;
  id_publication_review_type: number;
  editors_notification_mails: string;
  editors_cc: boolean;
  editors_cc_mails: string;
  abstract_word_limit: number;
  keywords_limit: number;
}

export const createPublicationSchema = z.object({
  name: z.string().min(1, "El nombre es obligatorio"),
  supplier_name: z.string().min(1, "Supplier name es obligatorio"),
  institution_name: z
    .string()
    .min(1, "El nombre de la institución es obligatorio"),
  slug: z.string().min(1, "El slug es obligatorio"),
  slug_2: z
    .string()
    .min(1, "El slug es obligatorio")
    .regex(
      /^[a-zA-Z0-9-]+$/,
      "El slug debe contener solo letras, números y guiones",
    )
    .refine((val) => !val.includes(".com"), "El slug no puede contener '.com'"),
  domain: z.string().min(1, "El dominio es obligatorio"),
  abbreviation: z.string().min(1, "La abreviatura es obligatoria"),
  issn: z.string().min(1, "El ISSN es obligatorio"),
  e_issn: z.string().min(1, "El E-ISSN es obligatorio"),
  publisher: z.string().min(1, "El editor es obligatorio"),
  doi_prefix: z.string().min(1, "El prefijo DOI es obligatorio"),
  logo_url: z.string().min(1, "La URL del logo es obligatoria"),
  favicon_url: z.string().min(1, "La URL del favicon es obligatoria"),
  internal_mailbox: z.string().min(1, "El buzón interno es obligatorio"),
  historic_archive_url: z
    .string()
    .min(1, "La URL del archivo histórico es obligatoria"),
  color_primary: z.string().min(1, "El color primario es obligatorio"),
  color_secondary: z.string().min(1, "El color secundario es obligatorio"),
  review_type: z.string().min(1, "El tipo de revisión es obligatorio"),
  id_language_1: z.number().min(1, "El idioma 1 es obligatorio"),
  id_language_2: z.number().min(1, "El idioma 2 es obligatorio"),
  id_language_3: z.number().min(1, "El idioma 3 es obligatorio"),
  about_text_short: z.string().min(1, "El texto corto es obligatorio"),
  about_text_long: z.string().min(1, "El texto largo es obligatorio"),
  comitee_text: z.string().min(1, "El texto del comité es obligatorio"),
  rules_text: z.string().min(1, "El texto de las reglas es obligatorio"),
  ethics_text: z.string().min(1, "El texto de ética es obligatorio"),
  financing_text: z
    .string()
    .min(1, "El texto de financiamiento es obligatorio"),
  publishing_cost: z.string().min(1, "El costo de publicación es obligatorio"),
  correspondence_contact: z
    .string()
    .min(1, "El contacto de correspondencia es obligatorio"),
  banner_policy: z.number().min(1, "La política de banner es obligatoria"),
  associated_editors: z.boolean(),
  production_platform: z.boolean(),
  publication_platform: z.boolean(),
  continuous_publication: z.boolean(),
  ahead_of_print: z.boolean(),
  reviewers_can_be_suggested: z.boolean(),
});

export interface supplierTypes {
  flag_disabled: boolean;
  modified_date: string;
  id: number;
  created_by: number;
  disabled_by: string;
  url_supplier: string;
  disabled_date: string;
  creation_date: string;
  modified_by: string;
  name: string;
  logo_url: string;
}

export interface requestSupplierTypes {
  slug?: string;
  name: string;
  url_supplier: string;
  logo_url: string;
}

export const createSupplierSchema = z.object({
  slug: z.string().optional(),
  name: z.string().min(1, "El nombre es obligatorio"),
  url_supplier: z.string().min(1, "La URL es obligatoria"),
  logo_url: z.string().min(1, "La URL del logo es obligatoria"),
});

export const createSupplierAdminSchema = z.object({
  name: z.string().min(1, "El nombre es obligatorio"),
  abbreviation: z.string().min(1, "La abreviación es obligatoria"),
  institution_name: z
    .string()
    .min(1, "El nombre de la institución es obligatorio"),
  domain: z.string().min(1, "El dominio es obligatorio"),
  slug: z
    .string()
    .min(1, "El slug es obligatorio")
    .regex(
      /^[a-zA-Z0-9-]+$/,
      "El slug debe contener solo letras, números y guiones",
    )
    .refine((val) => !val.includes(".com"), "El slug no puede contener '.com'"),
  review_type: z.string().min(1, "El tipo de revisión es obligatorio"),
});

export type createPublicationTypes = z.infer<typeof createPublicationSchema>;

export interface ChiefEditor {
  role: string;
  name: string;
  position: string;
  contact: string;
}

export interface CommitteeMember {
  name: string;
  position: string;
  contact: string;
}

export interface MagazineType {
  name: string;
  supplier_name: string;
  slug: string;
  domain: string;
  abbreviation: string;
  issn: string;
  publisher: string;
  doi_prefix: string;
  logo_url: string;
  banner_policy: number;
  internal_mailbox: string;
  color_primary: string;
  color_secondary: string;
  id_language_1: string;
  id_language_2: string;
  id_language_3: string;
  about_text_short: string;
  about_text_long: string;
  rules_text: string;
  ethics_text: string;
  copyright_text: string;
  associated_editors: string;
  production_platform: string;
  publication_platform: string;
  continuous_publication: string;
  comitee_text?: string;
  chief_editor?: ChiefEditor;
  committee_members?: CommitteeMember[];
  email?: string;
  privacy?: string;
  financing_text: string;
  publishing_cost: string;
  license_type: string;
  editorial_process: string;
  legal_notice: string;
  correspondence_contact: string;
  e_issn?: string;
  id_publication_review_type?: number;

  editors_notification_mails?: string;
  editors_cc?: boolean;
  editors_cc_mails?: string;

  telefono?: string;
  address?: string;
  index_logo_visible?: boolean;
  banners_visible?: boolean;
  news_visible?: boolean;
  revision_files_preview?: boolean;
}

export const editPublicationSchema = z.object({
  name: z.string().optional(),
  supplier_name: z.string().optional(),
  slug: z.string().optional(),
  domain: z.string().optional(),
  abbreviation: z.string().optional(),
  issn: z.string().optional(),
  e_issn: z.string().optional(),
  publisher: z.string().optional(),
  doi_prefix: z.string().optional(),
  logo_url: z.string().optional(),
  favicon_url: z.string().optional(),
  internal_mailbox: z.string().optional(),
  historic_archive_url: z.string().optional(),
  color_primary: z.string().optional(),
  color_secondary: z.string().optional(),
  id_language_1: z.number().optional(),
  id_language_2: z.number().optional(),
  id_language_3: z.number().optional(),
  about_text_short: z.string().optional(),
  about_text_long: z.string().optional(),
  rules_text: z.string().optional(),
  ethics_text: z.string().optional(),
  copyright_text: z.string().optional(),
  license_type: z.string().nullable().optional(),
  financing_text: z.string().optional(),
  publishing_cost: z.string().optional(),
  correspondence_contact: z.string().optional(),
  associated_editors: z.boolean().optional(),
  production_platform: z.string().optional(),
  publication_platform: z.string().optional(),
  continuous_publication: z.string().optional(),
  ahead_of_print: z.boolean().optional(),
  reviewers_can_be_suggested: z.boolean().optional(),
  id_publication_review_type: z.number().nullable().optional(),
  can_download_without_login: z.boolean().optional(),

  banner_19_url: z.string().optional(),
  banner_20_url: z.string().optional(),
  banner_21_url: z.string().optional(),

  article_counter: z.string().nullable().optional(),

  google_analytics_id: z.string().optional(),
  required_files_to_publish: z.string().optional(),
  footer_text: z.string().optional(),

  editors_notification_mails: z.string().optional(),
  editors_cc: z.boolean().optional(),
  editors_cc_mails: z.string().optional(),

  address: z.string().optional(),
  index_logo_visible: z.boolean().optional(),
  banners_visible: z.boolean().optional(),
  news_visible: z.boolean().optional(),

  chat_available: z.boolean().optional(),
  news_text: z.string().optional(),
  revision_files_preview: z.boolean().optional(),
});

export type editPublicationTypes = z.infer<typeof editPublicationSchema>;

export const supplierSchema = z.object({
  name: z.string().min(1, "Nombre es requerido"),
  logo_ul: z.string().optional(),
  phone: z.string().optional(),
  email: z.string().email("Email no válido").optional(),
});

export interface footerTypes {
  comitee_text?: string | null;
  rules_text?: string | null;
  ethics_text?: string | null;
  copyright_text?: string | null;
  license_type?: string | null;
  financing_text?: string | null;
  publishing_cost?: string | null;
  legal_notice?: string | null;
  privacy_policy?: string | null;

  publish_rules_general_aspects?: string | null;
  publish_rules_admission_process?: string | null;
  publish_rules_faq?: string | null;
  publish_rules_preparation_and_send?: string | null;
  metrics?: string | null;
  about_text_long?: string | null;
  correspondence_contact?: string | null;
  publish_rules_manuscript_types?: string | null;
  footer_text?: string | null;
  openaccess_text?: string | null;
  news_text?: string | null;
}

export interface editSupplierTypes {
  name?: string;
  url_supplier?: string;
  logo_url?: string;
}

export interface addLogoUrlTypes {
  file: FormData;
}

export interface addSupplierLogoTypes {
  supplier_slug: string;
  data: {
    file: FormData;
  };
}

export interface addBannerTypes {
  banner_number: number;
  data: FormData;
}

export interface userRoleTypes {
  orcid: string | null;
  first_name: string;
  middle_name: string | null;
  last_name: string | null;
  user_login: string;
  slug: string;
  affiliation: string | null;
  flag_disabled: boolean | null;
  flag_global_admin: boolean | null;
  job_description: string | null;
  specialisation: string | null;
  specialisation_2: string | null;
  government_id_number: string | null;
  city: string | null;
  country: string | null;
  actor_type: string;
}

export type ActorType =
  | "Author"
  | "Reviewer"
  | "Associated Editor"
  | "Main Editor";

export interface UserDataTypes {
  orcid: string;
  first_name: string;
  middle_name: string | null;
  last_name: string;
  user_login: string;
  slug: string;
  affiliation: string;
  flag_disabled: boolean | null;
  flag_global_admin: boolean;
  job_description: string | null;
  specialisation: string;
  specialisation_2: string | null;
  government_id_number: string | null;
  city: string | null;
  country: string | null;
  actor_type: ActorType[];
  author_slug: string;
  reviewer_slug: string | null;
  editor_slug: string | null;
}

export type UsersCollection = Record<string, UserDataTypes>;
export interface initialFooterTypes {
  comitee_text?: boolean;
  rules_text?: boolean;
  ethics_text: boolean;
  copyright_text: boolean;
  license_type: string;
  financing_text: boolean;
  publishing_cost: boolean;
  legal_notice: boolean;
  privacy_policy: boolean;
  publish_rules_general_aspects: boolean;
  publish_rules_admission_process: boolean;
  publish_rules_faq: boolean;
  publish_rules_preparation_and_send: boolean;
  metrics: boolean;
  about_text_long: boolean;
  correspondence_contact: boolean;
  publish_rules_manuscript_types: boolean;
  footer_text: string;
  openaccess_text: boolean;
  abbreviation: string;
}
export interface PublicationPoliciesTypes {
  comitee_text: string | null;
  rules_text: string | null;
  ethics_text: string | null;
  copyright_text: string | null;
  license_type: string | null;
  financing_text: string | null;
  publishing_cost: string | null;
  legal_notice: string | null;
  privacy_policy: string | null;
  publish_rules_general_aspects: string | null;
  publish_rules_admission_process: string | null;
  publish_rules_faq: string | null;
  publish_rules_preparation_and_send: string | null;
  footer_text: string | null;
  openaccess_text: string | null;
  news_text?: string | null;
}

export interface PublicationContactTypes {
  correspondence_contact: string | null;
  telefono: string | null;
  address: string | null;
}

export interface PublicationNewsTypes {
  news_text: string | null;
}

export interface PublicationBannersTypes {
  banner_1_url: string;
  banner_2_url: string;
  banner_3_url: string;
  banner_4_url: string;
  banner_5_url: string;
  banner_6_url: string;
  banner_7_url: string;
  banner_8_url: string;
  banner_9_url: string;
  banner_10_url: string;
  banner_11_url: string;
  banner_12_url: string;
  banner_13_url: string;
  banner_14_url: string;
  banner_15_url: string;
  banner_16_url: string;
  banner_17_url: string;
  banner_18_url: string;
  banner_19_url: string;
  banner_20_url: string;

  banner_1_type: number;
  banner_2_type: number;
  banner_3_type: number;
  banner_4_type: number;
  banner_5_type: number;
  banner_6_type: number;
  banner_7_type: number;
  banner_8_type: number;
  banner_9_type: number;
  banner_10_type: number;
  banner_11_type: number;
  banner_12_type: number;
  banner_13_type: number;
  banner_14_type: number;
  banner_15_type: number;
  banner_16_type: number;
  banner_17_type: number;
  banner_18_type: number;
  banner_19_type: number;
  banner_20_type: number;

  banner_1_visible: boolean;
  banner_2_visible: boolean;
  banner_3_visible: boolean;
  banner_4_visible: boolean;
  banner_5_visible: boolean;
  banner_6_visible: boolean;
  banner_7_visible: boolean;
  banner_8_visible: boolean;
  banner_9_visible: boolean;
  banner_10_visible: boolean;
  banner_11_visible: boolean;
  banner_12_visible: boolean;
  banner_13_visible: boolean;
  banner_14_visible: boolean;
  banner_15_visible: boolean;
  banner_16_visible: boolean;
  banner_17_visible: boolean;
  banner_18_visible: boolean;
  banner_19_visible: boolean;
  banner_20_visible: boolean;
}

export interface editFooterTypes {
  comitee_text?: string | null;
  rules_text?: string | null;
  ethics_text?: string | null;
  copyright_text?: string | null;
  license_type?: string | null;
  financing_text?: string | null;
  publishing_cost?: string | null;
  legal_notice?: string | null;
  privacy_policy?: string | null;
  publish_rules_general_aspects?: string | null;
  publish_rules_admission_process?: string | null;
  publish_rules_faq?: string | null;
  publish_rules_preparation_and_send?: string | null;
  footer_text?: string | null;
  openaccess_text?: string | null;
  about_text_long?: string | null;
  correspondence_contact?: string | null;
  metrics?: string | null;
  publish_rules_manuscript_types?: string | null;
  news_text?: string | null;
}

export interface SuccessType {
  message: string;
}
